const RANK: Record<string, number> = { viewer: 0, operator: 1, admin: 2 }
export type Role = 'viewer' | 'operator' | 'admin'
export const hasRole = (role: string | undefined, min: Role) =>
  (RANK[role ?? 'viewer'] ?? 0) >= RANK[min]
